import { IPitch, ISolfaNameType } from "../../../../../../common/types";
import { isEnglishSolfa } from "../../../../../../common/parameters";

export const fillSolfaNames = (solfaNameTypes: ISolfaNameType[]) => {
    let total = solfaNameTypes[solfaNameTypes.length - 1].i;
    for (let i = solfaNameTypes[0].i; i <= total; i++) {
        if (solfaNameTypes.findIndex(type => type.i === i) === -1) {
            solfaNameTypes.push({ i });
        }
    }
    solfaNameTypes.sort((a, b) => a.i - b.i);
    return solfaNameTypes;
};

const transformSolfa = [1, 3, 5, 0, 2, 4, 6];

export const isPitchSelected = (selectedPitch: IPitch | IPitch[] | undefined, solfaName: ISolfaNameType) => {
    if (!selectedPitch) return false;
    const pitches = Array.isArray(selectedPitch) ? selectedPitch : [selectedPitch];
    for (let pitch of pitches) {
        if (pitch.s === transformSolfa[solfaName.s!] && (pitch.o || 0) === (solfaName.o || 0)) {
            return true;
        }
    }
    return false;
};

export const getSolfaFlat = (solfaName: ISolfaNameType, locale: string, solfaKam: boolean) => {
    if (locale === "et" || solfaKam) return "u";
    if (isEnglishSolfa(locale)) {
        return solfaName.i % 7 === 1 ? "a" : "e";
    }
    return solfaName.i % 7 === 5 ? "o" : "a";
};